import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { RequireRole } from './components/RequireRole';
import { SessionProvider } from './context/SessionContext';
import { SiteConfigProvider } from './context/SiteConfigContext';
import { AddLetterPage } from './pages/AddLetterPage';
import { AddMemoryPage } from './pages/AddMemoryPage';
import { AdminPage } from './pages/AdminPage';
import { HomePage } from './pages/HomePage';
import { InvitePage } from './pages/InvitePage';
import { LettersPage } from './pages/LettersPage';
import { MemoriesPage } from './pages/MemoriesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PhotosPage } from './pages/PhotosPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { UploadPhotosPage } from './pages/UploadPhotosPage';

export function App() {
  return (
    <SiteConfigProvider>
      <SessionProvider>
        <div className="app-shell">
          <a className="skip-link" href="#main-content">
            Skip to the main content
          </a>

          <Header />

          <main id="main-content" className="app-main" tabIndex={-1}>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/memories" element={<MemoriesPage />} />
                <Route path="/letters" element={<LettersPage />} />
                <Route path="/photos" element={<PhotosPage />} />
                <Route
                  path="/add-memory"
                  element={
                    <RequireRole action="add a memory">
                      <AddMemoryPage />
                    </RequireRole>
                  }
                />
                <Route
                  path="/add-letter"
                  element={
                    <RequireRole action="write a letter">
                      <AddLetterPage />
                    </RequireRole>
                  }
                />
                <Route
                  path="/upload-photos"
                  element={
                    <RequireRole action="upload photographs">
                      <UploadPhotosPage />
                    </RequireRole>
                  }
                />
                <Route path="/invite/:token" element={<InvitePage />} />
                <Route
                  path="/admin"
                  element={
                    <RequireRole requires="administrator" action="look after this memorial">
                      <AdminPage />
                    </RequireRole>
                  }
                />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </ErrorBoundary>
          </main>

          <Footer />
        </div>
      </SessionProvider>
    </SiteConfigProvider>
  );
}
